import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

/**
 * Editorial chip. Intentionally narrow variant set to keep a calm visual
 * language — one weight for positive states (verified), one for neutral
 * service flags (bulk-bill, telehealth), one for urgency (coral), and a
 * muted ghost for meta.
 */
const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wider transition-colors",
  {
    variants: {
      variant: {
        verified:
          "border-pb-primary/20 bg-pb-primary-50 text-pb-primary",
        neutral:
          "border-pb-border bg-pb-surface text-pb-ink-2",
        urgent:
          "border-pb-accent/40 bg-pb-accent-50 text-pb-ink",
        muted:
          "border-transparent bg-pb-surface-2 text-pb-ink-3",
        danger:
          "border-pb-danger/30 bg-pb-danger/5 text-pb-danger",
      },
    },
    defaultVariants: { variant: "neutral" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
